import exactIcon from "../../assets/exact-logo.png";
import fortesIcon from "../../assets/fortes-logo.png";
import docubirdIcon from "../../assets/icon-64.png";
import simplicateIcon from "../../assets/simplicateTransparent.png";
import hordijkIcon from "../../assets/hordijk.jpg";
import univeIcon from "../../assets/univeTransparent.png";
import { BookingExpertsIcon } from "../../components/icons/BookingExpertsIcon";
import { KVKIcon } from "../../components/icons/KVKIcon";
import { Icon } from "@fluentui/react";

const dropdownImgStyle: React.CSSProperties = {
    maxHeight: "100%",
    maxWidth: "100%",
    height: 20,
    width: 20,
    objectFit: "contain",
    aspectRatio: "1",
    display: "flex",
    alignItems: "center",
    alignSelf: "center",
    justifyContent: "center",
    justifySelf: "center",
    marginRight: 5,
}

export const getDatasourceTypeIcon = (optionText: string, imgStyle?: React.CSSProperties): JSX.Element => {
    let icon: JSX.Element;
    const imageStyle: React.CSSProperties = imgStyle ?? dropdownImgStyle;
    const datasourceType: string = optionText?.toLowerCase();
    if (datasourceType === "univecrm") {
        icon = <img src={univeIcon} style={imageStyle} />
    }
    else if (datasourceType?.startsWith("sharepoint")) {
        icon = <img src="https://static2.sharepointonline.com/files/fabric/assets/brand-icons/product-fluent/png/sharepoint_32x1.png" style={imageStyle} />
    }
    else if (datasourceType?.startsWith("docubird")) {
        icon = <img src={docubirdIcon} style={imageStyle} />
    }
    else if (datasourceType?.startsWith("simplicate")) {
        icon = <img src={simplicateIcon} style={imageStyle} />
    }
    else if (datasourceType?.startsWith("hordijk")) {
        icon = <img src={hordijkIcon} style={imageStyle} />
    }
    else if (datasourceType?.startsWith("exact")) {
        icon = <img src={exactIcon} style={imageStyle} />
    }
    else if (datasourceType?.startsWith("kvk")) {
        icon = <KVKIcon style={imageStyle} />
    }
    else if (datasourceType?.startsWith("bookingexperts")) {
        icon = <BookingExpertsIcon style={imageStyle} />
    }
    else if (datasourceType?.startsWith("fortes")) {
        icon = <img src={fortesIcon} style={imageStyle} />
    }
    else {
        icon = <Icon iconName={"TableGroup"} style={{ ...imageStyle, fontSize: 22 }} />
    }
    return icon;
}